export default __webpack_public_path__ + "static/media/telusheart.106cea5b.png";